<template>
  <v-card flat color="transparent">
    <v-container fluid>
      <v-row no-gutters align-content="center" justify-content="start" style="margin-top: 10px; margin-bottom: 4px">
        <v-col cols="auto" align-self="center">
          <router-link :to="{ path: '/items'}" style="text-decoration:none;">
            <v-icon color="primary" class="mx-2">
              mdi-chevron-left
            </v-icon>Return to Items
          </router-link>
        </v-col>
        <v-divider class="mx-5" vertical></v-divider>
        <v-col cols="auto" align-self="center">
          <v-toolbar-title style="padding-top: 0; padding-bottom: 0; padding-left: 0">
            {{ (existingItem) ? `${item.description || ''}` : 'Create New' }}
          </v-toolbar-title>
        </v-col>
        <v-col cols="auto" class="col-auto ml-auto" align-self="center">
          <v-card-subtitle v-if="existingItem && item.item_id"
            style="margin: auto 10px 0 auto"
            class="text-capitalize text-body-1 pa-0">
            Id: {{ item.item_id }}
          </v-card-subtitle>
        </v-col>
      </v-row>
    </v-container>
    <v-card style="display: grid; min-height: 600px;">
      <div style="display: grid; align-content: flex-start; margin: 0; padding: 0;">
      <v-toolbar flat style="background-color: transparent">
        <v-card-title class="py-0 pr-0">
          <v-icon left>
            {{ existingItem ? 'mdi-note-text-outline' : 'mdi-account' }}
          </v-icon>
          {{ existingItem ? 'Item Details' : 'Create Item' }}
        </v-card-title>
        <v-spacer></v-spacer>
        <v-col cols="auto" class="d-flex justify-end align-center mr-2">
          <v-card-subtitle v-show="existingItem" class="ma-0 pa-0">
            Hide Empty Fields
          </v-card-subtitle>
          <v-switch
            v-show="existingItem"
            v-model="hideEmpty"
            class="my-auto ml-4 mr-4"
            color="success"
            :disabled="loading || saving"
            hide-details
            dense>
          </v-switch>
          <v-btn
            v-show="hasWriteAccess"
            :disabled="loading || saving"
            :loading="saving"
            color="success"
            :depressed="showUpdateSources"
            class="mr-0 pr-4"
            :style="showUpdateSources ? 'border-top-right-radius: 0px; border-bottom-right-radius: 0px; min-width: auto' : null"
            @click="saveItem">
            {{ existingItem ? 'Update' : 'Create' }}
            {{ (updateSources.length > 0) ? `(+${updateSources.length})` : '' }}
          </v-btn>
          <template v-if="showUpdateSources">
            <v-divider vertical dark></v-divider>
            <v-menu
              offset-y
              left
              :close-on-content-click="false">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="success"
                  v-on="on"
                  depressed
                  v-bind:attrs="attrs"
                  :disabled="loading || saving"
                  style="border-top-left-radius: 0px; border-bottom-left-radius: 0px; min-width: auto"
                  class="ml-0 px-2">
                  <v-icon dark class="pa-0 ma-0">mdi-chevron-down</v-icon>
                </v-btn>
              </template>
              <v-card flat min-width="200">
                <v-list dense subheader>
                  <v-list-item>
                    <v-list-item-action>
                      <v-checkbox
                        v-model="updateAll">
                      </v-checkbox>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>
                        All
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider></v-divider>
                  <v-list-item-group
                    v-model="updateSources"
                    multiple
                    dense>
                    <v-list-item
                      v-for="source in availableUpdateSources"
                      :key="source.source_id"
                      :value="source.source_id"
                      color="primary">
                      <template v-slot:default="{ active }">
                        <v-list-item-action>
                          <v-checkbox :input-value="active"></v-checkbox>
                        </v-list-item-action>
                        <v-list-item-content>
                          <v-list-item-title>
                            {{ source.source_name }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </template>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-card>
            </v-menu>
          </template>
          <v-btn
            v-show="hasWriteAccess && existingItem"
            :disabled="loading || saving || availableCopySources.length === 0"
            @click.stop="showCopyModal = true"
            class="ml-4">
            Copy
          </v-btn>
        </v-col>
      </v-toolbar>
      <template v-if="loading">
        <div style="display: grid; justify-content: center; align-content: center; padding: 50px; min-height: 100%; margin-top: 30px">
        <v-progress-circular
          :size="50"
          color="grey"
          indeterminate>
        </v-progress-circular>
        </div>
      </template>
      <template v-else>
      <template v-for="section in currentSections">
        <ItemData
          :ref="`item-${section.fields}`"
          :key="section.fields"
          v-model="editItem"
          :title="section.title"
          :fields="section.fields"
          :crud="crud"
          :upcRes="upcRes"
          :hideEmpty="hideEmpty"
          @upc="updateUpc"
          @resetUpcRes="() => upcRes = null">
        </ItemData>
      </template>
      </template>
      </div>
      <v-container fluid class="px-4" style="display: grid; align-content: flex-end; margin-top: auto">
      <v-row class="px-2 py-4">
          <v-col class="updated" v-if="existingItem && item.created_by">
            Created By: {{ item.created_by }}<br>
            Updated By: {{ item.last_update_user }}<br>
            Last Update: {{ formatDates(item.last_update_date, true) }}
          </v-col>
          <v-col cols="auto" class="d-flex justify-end">
         <!-- <v-btn v-if="crud === 'edit'"
            color="error"
            outlined
            @click="deleteItem">
            Delete Item
          </v-btn> -->
        </v-col>
      </v-row>
      </v-container>
    </v-card>
    <ItemCopyModal
      v-if="showCopyModal"
      :value.sync="showCopyModal"
      :item="item"
      :availableCopySources="availableCopySources"
      @updateCopySources="findExistingSources">
    </ItemCopyModal>
  </v-card>
</template>
<script>
import api from '@/api/endpoints'
import ItemData from './ItemData.vue'
const ItemCopyModal = () => import('@/components/items/ItemCopyModal.vue')
import { root } from '../../mixins/root'
import { cloneDeep } from 'lodash'
export default {
  name: 'itemBase',
  data () {
    return {
      crud: 'edit',
      editItem: {},
      item: {},
      loading: false,
      saving: false,
      showCopyModal: false,
      process: 'Standard',
      derivedSection: {
        fields: 'derived',
        title: 'Derived'
      },
      newItem: {
        item_id: null,
        source: null,
        barcode: null,
        upc: null,
        plu: null,
        pack_size: null,
        sale_price: '0',
        cost: '0',
        vendor_id: null,
        vendor_name: null,
        status: null,
        department: null,
        category: null,
        subcategory: null,
        metadata: {
          brand: null,
          brand_owner: null,
          is_private_label: null,
          department_number: null
        }
      },
      tenantMetadata: {
        pricechopper: {
          key: 'pce_metadata',
          label: 'PCE'
        }
      },
      upcRes: null,
      hideEmpty: false,
      existingSources: [],
      updateSources: [],
      itemVariants: [],
      updateAll: false
    }
  },
  components: { ItemData, ItemCopyModal },
  mixins: [root],
  watch: {
    updateAll: {
      handler (newValue) {
        if (newValue === false) {
          if (this.updateSources.length === this.availableUpdateSources.length) {
            this.updateSources = []
          }
        } else if (newValue === true) {
          this.updateSources = this.availableUpdateSources.map(s => s.source_id)
        }
      }
    },
    updateSources: {
      handler (newValue) {
        if (newValue && (this.updateAll === true)) {
          if (newValue.length !== this.availableUpdateSources.length) {
            this.updateAll = false
          }
        }
      },
      deep: true
    }
  },
  beforeCreate () {
    this.$store.dispatch("setSources")
  },
  async created () {
    this.loading = true
    if (!this.$auth.isAdmin) {
      await this.$store.dispatch('getUserRelatedParties').catch(err => {
        this.loading = false
        this.handleError(err)
      })
    }
    if (this.$route.query.id) {
      await this.initData()
    } else {
      this.crud = 'new'
      this.editItem = JSON.parse(JSON.stringify(this.newItem))
      this.loading = false
    }
  },
  computed: {
    dataSections () {
      let sections = [
        { fields: 'details', title: false },
        { fields: 'taxonomy', title: 'Taxonomy' },
        { fields: 'metadata', title: 'Metadata' }
      ]
      return sections
    },
    existingItem () {
      return Boolean(this.$route.query.id)
    },
    currentSections () {
      let sections = this.dataSections
      if (this.editItem.metadata && this.editItem.metadata.derived) {
        sections = [...sections, this.derivedSection]
      }
      if (this.editItem.metadata && this.tenantMetadata[this.$auth.tenant] && this.editItem.metadata[this.tenantMetadata[this.$auth.tenant].key]) {
        sections = [...sections, { fields: 'tenant_metadata', title: `${this.tenantMetadata[this.$auth.tenant].label} Metadata` }]
      }
      return sections
    },
    availableCopySources () {
      if (this.userSources && this.existingSources.length > 0) {
        const copySources = this.userSources.filter(s => s && !this.existingSources.includes(s.source_id))
        return this.sortSources(copySources)
      }
      return []
    },
    showUpdateSources () {
      return (this.hasUpdateMultipleAccess && this.userSources && (this.itemVariants.length > 0))
    },
    availableUpdateSources () {
      if (this.userSources && this.itemVariants.length > 0) {
        const updateSources = this.userSources.filter(s => s && this.existingSources.includes(s.source_id) && s.source_id !== this.item.source)
        return this.sortSources(updateSources)
      }
      return []
    },
    updateUUIDs () {
      if (this.updateSources.length > 0) {
        return this.itemVariants.flatMap(item => {
          return this.updateSources.includes(item.source)
            ? item.uuid
            : []
        })
      }
      return []
    }
  },
  methods: {
    async initData () {
      const id = this.$route.query.id
      this.loading = true
      let catalogName = this.retailerCatalog
      try { 
        if (this.$auth.tenant != 'jbg') {  
          catalogName = ''
        }
        const response = await api.getItemByUUID(id, catalogName)
        if (response) {
          this.item = response
          if (this.$auth.tenant === 'awg') {
            await this.findExistingSources()
          }
          const baseMetadata = JSON.parse(JSON.stringify(this.newItem.metadata))
          const editItem = JSON.parse(JSON.stringify(response))
          if (!this.item.metadata) {
            editItem.metadata = baseMetadata
          }
          this.editItem = editItem
          if (this.$auth.tenant !== 'awg') {
            this.setSourceMetadata()
          }
        }
      } catch (err) {
        this.handleError(err)
      } finally {
        this.loading = false
      }
    },
    async findExistingSources () {
      const payload = { item_id: this.item.item_id }
      let sources = []
      let itemVariants = []
      try {
        const data = await api.searchItems(payload)
        if (data && data.length > 0) {
          itemVariants = data.filter(item => item.uuid !== this.$route.query.id)
          sources = data.map(item => item.source)
        }
        this.existingSources = sources
        this.itemVariants = itemVariants
      } catch (err) {
        this.handleError(err)
      }
    },
    setSourceMetadata () {
      // source-specific metadata fields for item_master db view
      if (this.editItem.source.includes('spn')) {
        const { department_number, is_private_label, ...newMeta } = this.editItem.metadata
        this.editItem.metadata = newMeta
      } else if (this.item.source === 'awg') {
        const { is_private_label, ...newMeta } = this.editItem.metadata
        this.editItem.metadata = newMeta
      }
    },
    sortSources (sources) {
      if (sources && sources.length > 0) {
        return sources.sort((a, b) => {
          if (a && b) {
            const valA = a.source_name.toLowerCase()
            const valB = b.source_name.toLowerCase()
            if (valA < valB) return -1
            else if (valA > valB) return 1
            else return 0
          }
        })
      }
      return []
    },
    async saveItem () {
      const validForm = this.$refs['item-details'][0].submit()
      if (!validForm) {
        return this.emitAlert(true, 'warning', 'Please check your form for errors')
      }
      if (this.editItem.upc === "") this.editItem.upc = null
      if (this.$route.query.id) {
        await this.updateItem()
      } else {
        await this.createItem()
      }
    },
    async createItem () {
      this.saving = true
      try {
        const isValidUpc = await this.validateUpc()
        if (!isValidUpc) return

        if (this.$auth.tenant !== 'awg') {
          this.setSourceMetadata()
        }
        if (this.editItem.case_pack) {
          this.editItem.metadata.case_pack = this.editItem.case_pack
        }
        const response = await api.saveNewItem(this.editItem)
        if (response) {
          const { uuid } = response
          if (uuid) {
            this.emitAlert(true, 'success', 'Item created successfully', [], true)
            return this.$router.push({
              name: 'item', query: { id: uuid }
            }).then(() => {
              this.initData()
            })
          }
        }
      } catch (err) {
        this.handleError(err)
      } finally {
        this.saving = false
      }
    },
    async updateItem () {
      this.saving = true
      try {
        const isValidUpc = await this.validateUpc()
        if (!isValidUpc) return

        if (this.editItem.case_pack) {
          this.editItem.metadata.case_pack = this.editItem.case_pack
        }
        const payload = cloneDeep(this.editItem)
        if (this.updateSources.length > 0) {
          payload.update_uuids = [...this.updateUUIDs]
        }
        const response = await api.updateItem(payload)
        if (response && response.status === 'Success') {
          const message = payload.update_uuids
            ? 'Items updated successfully'
            : 'Item updated successfully'
          this.emitAlert(true, 'success', message, [], true)
          return this.initData()
        }
      } catch (err) {
        this.handleError(err)
      } finally {
        this.saving = false
      }
    },
    async validateUpc () {
      if (this.editItem.upc && this.editItem.upc.length > 0) {
        const upcRes = await api.verifyUpc(this.editItem.upc)
        if (!upcRes.standardized_upc.original_is_valid) {
          this.loading = false
          this.upcRes = upcRes.standardized_upc
          return false
        }
      }
      return true
    },
    updateUpc (val) {
      this.editItem.upc = val
      this.upcRes = null
    },
    async deleteItem () {
      try {
        if (confirm('Are you sure you want to delete this item?')) {
          this.loading = true
          const { uuid } = this.editItem
          await api.deleteItem(uuid)
          this.loading = false
          return this.$router.push('/items')
        }
      } catch (err) {
        this.loading = false
        console.log(err)
        throw err
      }
    }
  }
}
</script>
<style lang='less' scoped>
.updated {
  font-size: small;
  font-weight: 400;
  font-style: italic;
}

form {
  display: flex;
  flex-flow: column;
}
/deep/ .breadcrumbs {
  padding-bottom: 1rem;
}

.item-desc {
  text-transform: capitalize;
}
.left {
  float: left;
  line-height: 1;
  h2, h4, h5 {
    line-height:1;
  }
  h4 {
    font-weight: 400;
  }
  h5 {
    padding-bottom: 1rem;
  }
}
.source {
  float: right;
  text-align: right;
  line-height: 1;
  h4 {
    line-height: 1;
  }
}
.taxonomy{
  clear: both;
  padding-left: 0;

  li{
    display: inline-flex;
    font-size: .8rem;
    line-height: 1;
    text-transform: capitalize;
    font-weight: 400;
    align-items: center;
    &:after {
      content: '/';
      padding-left: .5rem;
      padding-right: .5rem;
      display: inline-block;
      font-size: 1.25rem;
    }
    &:last-child:after {
      content: ''
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/items/item.vue